export default[
    {
        path: '/notas/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro da anotação do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/notas/trabalhador/lista',
        name: 'lista da anotação do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/notas/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar anotação do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]